module.exports = __webpack_public_path__ + "static/img/ent-detail-42.f891af9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-42.jpg
// module id = UoEs
// module chunks = 51